import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../../../context/app';
import { useCampusComparison } from '../../../hooks/useCampusComparison';
import { useKioskManager } from '../../../hooks/useKioskManager';
import { useNavigationManager } from '../../../hooks/useNavigationManager';
import { DirectionsList } from '../directionsList/DirectionsList';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import { LegTwoInstruction } from '../LegTwoNavStep/LegTwoInstruction';
import styles from './LegTwoDirectionsList.module.scss';

interface LegTwoTextStepsProps {
  collapsed: boolean;
  printMode?: boolean;
}
export const LegTwoDirectionsList: React.FC<LegTwoTextStepsProps> = ({
  collapsed,
  printMode,
}) => {
  const {
    navDestinationPlace,
    legTwoFocusedStep,
    setLegTwoFocusedStep,
    setLegToggle,
  } = useContext(AppContext);
  const { legTwoRoute } = useNavigationManager();
  const { isSameCampus } = useCampusComparison();
  const { t } = useTranslation('common');
  const { kioskMode, kiosk } = useKioskManager();

  useEffect(() => setLegTwoFocusedStep(0), [setLegTwoFocusedStep]);

  if (!legTwoRoute) return null;

  return (
    <>
      {/*show leg two title when on kiosk*/}
      {kioskMode && (
        <h2 className={`${kiosk && kioskMode && styles[kiosk.model]}`}>
          {t('campusNavigation.form.directions')}
        </h2>
      )}
      <DirectionsList
        collapsed={collapsed}
        onClick={(val) => setLegToggle(!val)}
        title={(!kioskMode && t('campusNavigation.directions.step2')) || ''}
        whereTo={
          t('campusNavigation.directions.walkingTo') + navDestinationPlace?.name
        }
        printMode={printMode}
      >
        {/*Not on kiosk and only showing walking directions - display bold subtitle*/}
        {!kioskMode && isSameCampus && (
          <span className={styles.boldSectionHeader}>
            <Icon icon={IconType.WALKING} />
            {t('campusNavigation.directions.walkingTo') +
              navDestinationPlace?.name}
          </span>
        )}
        {legTwoRoute?.navSteps.map((step, index) => (
          <LegTwoInstruction
            key={index}
            step={step}
            onClick={() => !printMode && setLegTwoFocusedStep(index)}
            isFocused={legTwoFocusedStep === index}
            stepNumber={index + 1}
            printMode={printMode}
            nextStep={legTwoRoute?.navSteps[index + 1]}
          />
        ))}
      </DirectionsList>
    </>
  );
};
